import React from 'react';

const DeleteVariant = ({ variant, onDelete, isDeleting }) => {
  return (
    <div className="text-center sm:text-left">
      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0">
        <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
      </div>
      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
        <h3 className="text-base font-semibold leading-6 text-gray-900">
          Supprimer la variante
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            Êtes-vous sûr de vouloir supprimer la variante <span className="font-medium text-gray-700">"{variant.name}"</span> ?
            Cette action est irréversible et supprimera également toutes les valeurs associées à cette variante.
          </p>
          
          {variant.values && variant.values.length > 0 && (
            <div className="mt-3 bg-gray-50 rounded-md p-3">
              <p className="text-xs text-gray-500 mb-1">Valeurs qui seront supprimées :</p>
              <div className="flex flex-wrap gap-1 max-h-24 overflow-y-auto">
                {variant.values.map((value, index) => (
                  <span key={value.id || index} className="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700">
                    {value.value}
                  </span>
                ))}
              </div>
            </div>
          )}
          
          {isDeleting && (
            <div className="mt-3 flex items-center justify-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-red-700"></div>
              <span className="ml-2 text-sm text-gray-500">Suppression en cours...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteVariant;